import { render } from "./PropertyOneCModal.vue?vue&type=template&id=3f70fbe2"
import script from "./PropertyOneCModal.vue?vue&type=script&lang=js"
export * from "./PropertyOneCModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__